import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, takeUntil, withLatestFrom } from 'rxjs';
import { Store } from '@ngrx/store';
import { CaptchaActions } from '@app/core/actions';
import { NgHcaptchaService } from 'ng-hcaptcha';
import * as fromRoot from '@app/reducers/index';

@Injectable({
    providedIn: 'root'
})
export class ResolveCaptchaService {

    constructor(
        private readonly store$: Store<fromRoot.State>,
        private hcaptchaService: NgHcaptchaService
    ) { }

    resolve({ action }: { action: string }): Observable<{ captchaResponse: string, captchaError: string }> {
        this.store$.dispatch(CaptchaActions.ResetVerifyCaptcha());
        this.hcaptchaService.verify().subscribe({
            next: (token) => {
                this.store$.dispatch(CaptchaActions.VerifyCaptcha({ token, action }));
            }
        })
        const resolvedCaptcha$ = new ReplaySubject<{ captchaResponse: string, captchaError: string }>();
        this.store$.pipe(
            withLatestFrom(
                this.store$.select(fromRoot.getVerifyCaptchaResponse),
                this.store$.select(fromRoot.getVerifyCaptchaError),
            ),
            takeUntil(resolvedCaptcha$)
        ).subscribe(([store,
            captchaResponse, captchaError,
        ]) => {
            if (captchaResponse || captchaError) {
                resolvedCaptcha$.next({ captchaResponse, captchaError });
            }
        });

        return resolvedCaptcha$.asObservable();
    }

}